module.exports = function() {
  return new Worker(__webpack_public_path__ + "dcf0cf6127c23933f96b.worker.js");
};